// comment data
// コメントデータ、操作に関するもの集約、mutations、actions一通り書いたら整理（場合により分割）
import api from '@/api/commentApi'

const state = {
  entryID: 0,
  comments: [], // 全コメントデータ、コメント表示状態
  commentsLength: 0, // コメント（通常のみ）
  commentsMaxLength: 0, // コメント総数（通常+返信）
  pageMax: 0, // ページ総数
  pageCurrent: 1, // 現在ページ
  pagerArr: [], // ページネーション出力用
  entryUrl: '', // cx用 記事URL
  entryTitle: '', // cx用 記事タイトル
  pageLimit: 30, // コメント1ページ表示数
  replyFirstLimit: 3, // 返信コメント初回表示数
  replyLimit: 30 // 返信コメントもっと見る表示数
}

const mutations = {
  setEntryID: (state, entryId) => {
    state.entryID = entryId
  },
  // mutations コメントデータ、機能状態
  commentsGet: (state, payload) => {
    // console.log(payload, 'payload:commentsGet mutations')
    // entry_id
    state.entryID = payload.entry_id
    // コメントデータ
    state.comments = payload.comments || []
    // コメント総数（通常+返信）
    state.commentsMaxLength = payload.total_count || 0
    // コメント数（通常のみ）
    state.commentsLength = payload.count || 0
    // ページ総数
    const pageLimit = state.pageLimit
    state.pageMax = Math.ceil(state.commentsLength / pageLimit)
    // 現在ページ
    state.pageCurrent = payload.page || 1
    // ページネーション
    const maxView = 5 // ページネーションボタン表示数
    const diff = 2 // ページネーション前後差分
    const isOverMin = state.pageCurrent - diff < 1
    const isOverMax = state.pageCurrent + diff > state.pageMax
    // ページボタン出力数
    let output = (maxView >= state.pageMax) ? state.pageMax : maxView
    // 何番目から表示するか pageMaxがmaxView以下を追加 2018.4.26
    let setMin = (isOverMin || maxView >= state.pageMax) ? 1 : (isOverMax) ? state.pageMax - maxView + 1 : state.pageCurrent - diff
    state.pagerArr = [...Array(output)].map((v, i) => i + setMin)
  },

  // mutations 返信コメント
  replyCommentsGet: (state, payload) => {
    // console.log(payload, 'payload:replyCommentsGet mutations')
    // 返信コメント追加 先頭に追加 unshift 後方に追加 差分データにアニメーションが当たるので昇順だとアニメーションも逆
    // const replyReverse = payload.reply.reverse()
    state.comments[payload.commentIndex].reply.unshift(...payload.reply)
    // 返信コメント追加 後方に追加
    // state.comments[payload.commentIndex].reply.push(...payload.reply)

    // コメントデータ内 pager アップデート
    state.comments[payload.commentIndex].replyPager.replyPageCurrent = payload.page
    const max = state.comments[payload.commentIndex].replyPager.replyPageMax
    state.comments[payload.commentIndex].replyPager.replyMoreFlag = (max > payload.page)
  },

  // mutations 表示コメント追加
  commentSubmit: (state, payload) => {
    // console.log(payload, 'payload:commentSubmit mutations')
    // payload : updateComment i commentID
    if (!(payload.replyPostFlag)) { // 通常コメント
      global.cX.callQueue.push(['sendEvent', 'jct-news_comment', {url: state.entryUrl, title: state.entryTitle}])
      // state.comments.splice(0, 0, payload.updateComment)
      state.comments.unshift(payload.updateComment)
    } else { // 返信コメント commentIDは親コメントのuuid = replykey
      global.cX.callQueue.push(['sendEvent', 'jct-news_response', { url: state.entryUrl, title: state.entryTitle, comment_id: payload.commentID }])
      state.comments[payload.i].reply.push(payload.updateComment)
    }
    // console.log('コメント投稿後のstate.comments', state.comments)
  },

  // mutations 表示コメント削除
  commentDelete: (state, payload) => {
    // payload : commentsNum replyCommentsNum replyDeleteFlag commentID
    // cx 削除 送信
    global.cX.callQueue.push(['sendEvent', 'jct-news_del_comment', { url: state.entryUrl, title: state.entryTitle, comment_id: payload.commentID }])

    if (!(payload.replyDeleteFlag)) { // 通常コメント
      state.comments[payload.commentsNum].status = 1
      state.comments[payload.commentsNum].commentView.optionBtnFlag = false
      state.comments[payload.commentsNum].commentView.voteBtnFlag = false
    } else { // 返信コメント
      state.comments[payload.commentsNum].reply[payload.replyCommentsNum].status = 1
      state.comments[payload.commentsNum].reply[payload.replyCommentsNum].commentView.optionBtnFlag = false
      state.comments[payload.commentsNum].reply[payload.replyCommentsNum].commentView.voteBtnFlag = false
    }
  },

  // mutations 表示goodbad
  commentVote: (state, payload) => {
    // payload : commentsNum replyCommentsNum replyVoteFlag goodBad commentID
    // cx vote 送信
    global.cX.callQueue.push(['sendEvent', 'jct-news_goodbad', { url: state.entryUrl, title: state.entryTitle, comment_id: payload.commentID }])
    // cx good bad別送信
    global.cX.callQueue.push(['sendEvent', 'jct-news_' + payload.goodBad, { url: state.entryUrl, title: state.entryTitle, comment_id: payload.commentID }])

    // vote成功時
    if (!(payload.replyVoteFlag)) { // 通常コメント
      let voteNum = state.comments[payload.commentsNum][payload.goodBad]
      state.comments[payload.commentsNum][payload.goodBad] = voteNum + 1
      // console.log(state.comments[payload.commentsNum][payload.goodBad], 'vote')
      // console.log(state.comments[payload.commentsNum].body)
    } else { // 返信コメント commentIDは親コメントのuuid = replykey
      let voteRepNum = state.comments[payload.commentsNum].reply[payload.replyCommentsNum][payload.goodBad]
      state.comments[payload.commentsNum].reply[payload.replyCommentsNum][payload.goodBad] = voteRepNum + 1
      // console.log(state.comments[payload.commentsNum].reply[payload.replyCommentsNum][payload.goodBad])
      // console.log(state.comments[payload.commentsNum].reply[payload.replyCommentsNum].body)
    }
    // console.log('goodbad後のstate.comments', state.comments)
  },

  // mutations ページURL、タイトル登録
  entryDataSet: (state, payload) => {
    state.entryUrl = payload.entry_url
    state.entryTitle = payload.entry_title
  },

  // mutations 返信表示非表示
  replyShowHide: (state, payload) => {
    state.comments[payload.index].commentView.replyShowFlag = !state.comments[payload.index].commentView.replyShowFlag
  },

  replyFlagSet: (state, payload) => {
    state.comments[payload.index].commentView.replyShowFlag = payload.show
  }
}

// action → mutations -------------------------------
const actions = {
  // actions 記事ページ URL タイトル
  entryDataSet: ({ commit, rootState }, payload) => {
    commit('entryDataSet', { 'entry_url': payload.entry_url, 'entry_title': payload.entry_title })
  },

  // actions コメントデータ取得、成形
  commentsGet: ({ commit, rootState }, payload) => {
    // payload = page, entry_id pagetype
    // console.log(payload, 'payload:commentsGet actions')

    // 一覧、ピックアップ判定は payload.pageTypeで
    api.getComments(payload).then(commentsData => {
      // 見た目管理データ追加
      const addCommentsView = commentsData.data.comments.map(function (value) {
        // コメント機能状態 記事、一覧はflagでBoolean値を変更して対応
        // 過去記事は機能なし、判定は comments.import内にmovableTypeとあれば、過去記事
        // value.import === '' || value.import === undefined 変更予定
        value.commentView = {
          optionBtnFlag: value.status === 0 && value.member_id !== 'MT', // オプションボタン表示非表示 コメントのstatusが0でtrue
          replyBtnFlag: (value.status === 0 && value.member_id !== 'MT') || (value.member_id !== 'MT' && value.replyCount !== 0), // value.status === 0 || (value.member_id !== 'MT' && value.replyCount !== 0), // 返信コメントボタン表示非表示
          replyShowFlag: false, // 返信コメント表示非表示
          voteBtnFlag: value.status === 0 && value.member_id !== 'MT', // good badボタン表示非表示
          submitCommentFlag: false // 即時反映コメント判定
        }

        let replyLength = value.replyCount
        if (replyLength > 0) {
          // 返信コメントがある場合
          for (let i in value.reply) {
            // 返信コメント機能状態
            value.reply[i].commentView = {
              optionBtnFlag: value.reply[i].status === 0, // オプションボタン表示非表示
              replyBtnFlag: false, // 返信コメントボタン表示非表示
              replyShowFlag: false, // 返信コメント表示非表示
              voteBtnFlag: value.reply[i].status === 0, // good badボタン表示非表示
              submitCommentFlag: false // 即時反映コメント判定
            }
          }
        } else {
          // 返信コメントがない場合
          value.reply = []
        }

        // 返信コメント ページネーション 初回
        const replyFirstLimit = state.replyFirstLimit // 3 // 初回表示数
        const replyLimit = state.replyLimit // 30 // もっと見る
        value.replyPager = {
          replyMoreFlag: (replyLength > replyFirstLimit), // 初回返信コメントもっと見る表示
          replyPageCurrent: 0, // Curren返信コメント
          replyPageMax: (replyLength - replyFirstLimit > 0) ? Math.ceil((replyLength - replyFirstLimit) / replyLimit) : 0
          // 最大返信コメントページ数 replyFirstLimitを引いて残り何回表示させられるか
        }
        return value
      })

      commentsData.data.comments = addCommentsView
      commit('commentsGet', commentsData.data)
    }).catch(error => {
      // エラー処理
      // entry_idのみ送信
      commit('commentsGet', {entry_id: payload.entry_id, pageType: payload.pageType})

      // エラーモーダル表示
      // 404以外処理
      if (error.status !== 404) {
        // const errorMessage = (error.data !== undefined) ? error.data.error + 'api.getComments' : 'Error api.getComments'
        // commit('modal/setModalError', { name: 'modalError', message: errorMessage }, { root: true })
      } else { // テストのため記載
        // console.log('comments:404')
      }
    })
  },

  // actions 返信コメント取得
  replyCommentsGet: ({ commit, rootState }, payload) => {
    // console.log(payload, 'replyCommentsGet action')
    // payload :  replyKey i pager
    // n paeg はpager内 payload.pager.replyPageCurrent +1
    // console.log(payload.pager.replyPageCurrent)
    return api.getReplyComments(payload).then(replyCommentsData => {
      // 見た目管理データ追加
      const addReplyView = replyCommentsData.data.reply.map(function (value) {
        // コメント機能状態
        value.commentView = {
          optionBtnFlag: value.status === 0, // オプションボタン表示非表示
          replyBtnFlag: false, // 返信コメントボタン表示非表示
          replyShowFlag: false, // 返信コメント表示非表示
          voteBtnFlag: value.status === 0, // good badボタン表示非表示
          submitCommentFlag: true // 即時反映コメント判定
        }
        return value
      })

      replyCommentsData.data.reply = addReplyView
      replyCommentsData.data.commentIndex = payload.i
      commit('replyCommentsGet', replyCommentsData.data)
      return true
    }).catch(error => {
      // エラーモーダル表示
      const errorMessage = (error.data !== undefined) ? error.data.error : 'Error'
      commit('modal/setModalError', { name: 'modalError', message: errorMessage }, { root: true })
      return false
    })
  },

  // actions コメント追加
  commentSubmit: ({ commit, rootState }, payload) => {
    // payload: replyKey
    const submitComment = payload.postComment
    // console.log(payload, 'submitComment')

    // post for api.postComment
    const postContents = {
      'entryID': state.entryID,
      'postBody': { 'body': submitComment },
      'replyPostFlag': payload.replyPostFlag,
      'replyKey': payload.replyKey
    }

    // post後 処理が必要なので return している
    return api.postComment(postContents).then(entry => {
      // console.log('post成功', entry.data)

      const newComment = entry.data
      newComment.commentView = {
        optionBtnFlag: true, // オプションボタン表示非表示
        replyBtnFlag: !payload.replyPostFlag, // 返信コメントボタン表示非表示
        replyShowFlag: false, // 返信コメント表示非表示
        voteBtnFlag: true, // good badボタン表示非表示
        submitCommentFlag: true // 即時反映コメント判定
      }
      if (!payload.replyPostFlag) {
        newComment.replyCount = 0
        newComment.replyPager = {
          replyMoreFlag: false,
          replyPageCurrent: 0,
          replyPageMax: 0
        }
      }
      const updateCommentData = {
        'replyPostFlag': payload.replyPostFlag,
        'commentID': payload.replyKey, // cx用コメントID
        'i': payload.i, // 返信コメントのみアリ
        'updateComment': newComment
      }

      commit('commentSubmit', updateCommentData)
      return true
    }).catch(error => {
      // console.log('post失敗')
      // エラーモーダル表示
      const errorMessage = (error.data !== undefined) ? error.data.error : 'Error'
      commit('modal/setModalError', { name: 'modalError', message: errorMessage }, { root: true })
      return false
    })
  },

  // actions コメント削除
  commentDelete: ({ commit, rootState }, payload) => {
    // payload: deleteUuid deleteReplyKey
    // 返信コメントか否か
    const replyDeleteFlag = (payload.deleteReplyKey !== undefined)

    // 配列内のコメント捜査
    let deletionPos = {
      'commentsNum': 0, // state.comments.findIndex（uuid === payload.deleteUuid）で置き換え
      'replyCommentsNum': 0, // state.comments.findIndex（uuid === payload.deleteReplyKey）で置き換え
      'replyDeleteFlag': replyDeleteFlag,
      'commentID': payload.deleteUuid
    }
    if (!(replyDeleteFlag)) { // 通常コメント
      // findIndexはIEだめっぽい 互換コード:https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
      deletionPos.commentsNum = state.comments.findIndex(function (o) {
        return o.uuid === payload.deleteUuid
      })
    } else { // 返信コメント 親uuid = reply_key o=object
      deletionPos.commentsNum = state.comments.findIndex(function (o, i) {
        return o.uuid === payload.deleteReplyKey
      })
      // 返信親コメント 自身uuid = reply_key
      deletionPos.replyCommentsNum = state.comments[deletionPos.commentsNum].reply.findIndex(function (o) {
        return o.uuid === payload.deleteUuid
      })
    }

    const deletion = { // deleteにしたいが予約語なので delete → deletion
      'entryID': state.entryID,
      'replyDeleteFlag': replyDeleteFlag,
      'uuid': payload.deleteUuid,
      'replyKey': payload.deleteReplyKey
    }
    return api.deleteComment(deletion).then(commentsData => {
      // console.log('コメント削除した')
      commit('modal/hideModal', null, { root: true })
      commit('commentDelete', deletionPos)
      return true
    }).catch(error => {
      // エラーモーダル表示
      // console.log('コメント削除できない')
      const errorMessage = (error.data !== undefined) ? error.data.error : 'Error'
      commit('modal/setModalError', { name: 'modalError', message: errorMessage }, { root: true })
      return false
    })
  },

  // actions goodbad
  commentVote: ({ commit, rootState }, payload) => {
    // payload: goodBad uuid replyKey
    // 返信コメントか否か
    const replyVoteFlag = (payload.replyKey !== undefined)

    // 配列内のコメント捜査
    let votePos = {
      'commentsNum': 0, // state.comments.findIndex（uuid === payload.uuid）で置き換え
      'replyCommentsNum': 0, // state.comments.findIndex（uuid === payload.replyKey）で置き換え
      'replyVoteFlag': replyVoteFlag,
      'goodBad': payload.goodBad,
      'commentID': payload.uuid
    }
    if (!(replyVoteFlag)) { // 通常コメント
      votePos.commentsNum = state.comments.findIndex(function (o) {
        return o.uuid === payload.uuid
      })
    } else { // 返信コメント 親uuid = reply_key
      votePos.commentsNum = state.comments.findIndex(function (o, i) {
        return o.uuid === payload.replyKey
      })
      // 返信親コメント 自身uuid = reply_key
      votePos.replyCommentsNum = state.comments[votePos.commentsNum].reply.findIndex(function (o) {
        return o.uuid === payload.uuid
      })
    }

    const vote = {
      'entryID': state.entryID,
      'replyVoteFlag': replyVoteFlag,
      'uuid': payload.uuid,
      'replyKey': payload.replyKey,
      'goodBad': payload.goodBad
    }

    return api.voteComment(vote).then(commentsData => {
      // promiseってthen内の処理でエラーが出るとcatchが反応する
      // console.log('voteした', commentsData)
      commit('commentVote', votePos)
      return true
    }).catch(error => {
      // console.log('voteできない', error)
      // エラーモーダル表示
      const errorMessage = (error.data !== undefined) ? error.data.error : 'Error'
      commit('modal/setModalError', { name: 'modalError', message: errorMessage }, { root: true })
      return false
    })
  },

  // actions 返信コメント表示非表示
  replyShowHide: ({ commit }, index) => {
    commit('replyShowHide', {index: index})
  },
  replyFlagSet: ({ commit }, data) => {
    commit('replyFlagSet', data)
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/components/commentsData.js